"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductOffers;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _icon = require("@site/pattern-library-utils/icon");
const OffersContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "OffersContainer",
  class: "pl-osxh6t8"
});
function parsePackageNames(productsArray) {
  productsArray = productsArray || [];
  const productsObj = [];
  productsArray.map(product => {
    const thisGroup = {
      GroupOrder: product.GroupOrder,
      GroupAllowedQuantity: product.GroupAllowedQuantity,
      GroupId: product.GroupId,
      GroupDescription: product.GroupDescription,
      items: []
    };
    const groupOrder = thisGroup.GroupOrder - 1;
    productsObj[groupOrder] = productsObj[groupOrder] || thisGroup;
    productsObj[groupOrder].items.push(product);
  });
  return productsObj;
}
const MoreThanOne = quantity => {
  if (quantity > 1) {
    return /*#__PURE__*/_react.default.createElement("span", null, "(", quantity, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "x",
      width: 12,
      height: 12
    }), ")");
  }
  return null;
};
const ProductDescription = props => {
  const {
    group,
    orSeparator,
    oneOfTheFollowing
  } = props;
  const {
    items = []
  } = group;
  if (items?.length > 1) {
    var tmp = [];
    items.map(item => {
      tmp.push(item.ProductInfoFriendlyDescription);
    });
    const list = orSeparator.replace('{1}', () => {
      return tmp.pop();
    }).replace('{0}', () => {
      return tmp.join(', ');
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-cy": "one-of"
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "font-primary-bold"
    }, oneOfTheFollowing), list);
  } else if (items.length === 1) {
    return /*#__PURE__*/_react.default.createElement("div", {
      "data-cy": "product-description"
    }, /*#__PURE__*/_react.default.createElement(MoreThanOne, {
      quantity: items[0].Quantity
    }), items[0].ProductInfoFriendlyDescription);
  }
};
ProductDescription.propTypes = {
  group: _propTypes.default.shape({
    items: _propTypes.default.array
  }),
  orSeparator: _propTypes.default.string,
  oneOfTheFollowing: _propTypes.default.string
};
function ProductOffers({
  products,
  orSeparator,
  oneOfTheFollowing
}) {
  const groups = parsePackageNames(products);
  return /*#__PURE__*/_react.default.createElement(OffersContainer, {
    "data-cy": "product-offers",
    className: "redemption-content-offer-container"
  }, groups && groups.map((productGroup, i) => {
    return /*#__PURE__*/_react.default.createElement(ProductDescription, {
      group: productGroup,
      orSeparator: orSeparator,
      oneOfTheFollowing: oneOfTheFollowing,
      key: `${i}productDescription`
    });
  }));
}
ProductOffers.propTypes = {
  products: _propTypes.default.array.isRequired,
  orSeparator: _propTypes.default.string.isRequired,
  oneOfTheFollowing: _propTypes.default.string.isRequired
};
ProductOffers;